function peek(n) {
  n = n || 0
  return this[this.length - (n + 1)]
}
export default function () {
  var stack = []
  // @ts-ignore
  stack.peek = peek
  return stack
}


// WEBPACK FOOTER //
// ./src/common/components/process-editor/modules/dinnerSvg/parser/makeStack.js